'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Dependencies: jQuery, loader.scss

var AjaxChildPage = function () {
	function AjaxChildPage(nav, content_wrapper) {
		_classCallCheck(this, AjaxChildPage);

		this.$nav = $('.' + nav);
		this.$wrapper = $('.' + content_wrapper);
		this.wrapper = content_wrapper;
		this.$links = this.$nav.find('a');
		this.loader = '<div class="loader-wrapper"><div class="loader"></div</div>';
		this.loader_class = 'loader-wrapper';

		this.handleClick();
	}

	_createClass(AjaxChildPage, [{
		key: 'handleClick',
		value: function handleClick() {
			var self = this;
			this.$links.on('click', function (e) {
				var _this = this;

				e.preventDefault();
				self.handleContentRemoval(function () {
					self.next_url = $(_this).attr('href');
					self.handleGettingContent(function (success_message) {
						self.handleUrlUpdate();
						self.handleSettingContent();
					}, function (error_message) {
						self.handleSettingContent(true);
					});
				});
			});
		}
	}, {
		key: 'handleContentRemoval',
		value: function handleContentRemoval(callback) {
			var _this2 = this;

			this.$wrapper.css('height', this.$wrapper.outerHeight());
			this.$wrapper.animate({
				opacity: 0
			}, 150, function () {
				_this2.content = _this2.$wrapper.html();
				setTimeout(function () {
					$(_this2.loader).insertBefore(_this2.$wrapper).addClass('active');
				}, 0);
				if (callback) callback();
			});
		}
	}, {
		key: 'handleGettingContent',
		value: function handleGettingContent(callback_success, callback_fail) {
			var _this3 = this;

			$.ajax({
				url: this.next_url,
				context: document.body
			}).done(function (data) {
				_this3.next_title = $(data).filter('title').text();
				_this3.content = $(data).find('.' + _this3.wrapper);
				callback_success('Ajax succeeded');
			}).fail(function () {
				callback_fail('Ajax failed');
			});
		}
	}, {
		key: 'handleSettingContent',
		value: function handleSettingContent() {
			var _this4 = this;

			var has_error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

			$('.' + this.loader_class).removeClass('active');
			setTimeout(function () {
				return $('.' + _this4.loader_class).remove();
			}, 0.15);
			this.$wrapper.html(this.content);
			this.trigger('content-set');

			if (has_error && this.$wrapper.find('.ajax-error').length === 0) this.$wrapper.prepend('<h2 class="ajax-error">Error! There was a problem getting that page</h2>');

			this.$wrapper.css('height', 'initial');
			this.$wrapper.animate({
				opacity: 1
			}, 150);
		}
	}, {
		key: 'handleUrlUpdate',
		value: function handleUrlUpdate() {
			window.history.pushState({
				'pageTitle': this.next_title
			}, '', this.next_url);
		}
	}]);

	return AjaxChildPage;
}();